(function () {
  // Format money with Shopify or fallback
  function money(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      try {
        return Shopify.formatMoney(cents, window.Shopify.money_format);
      } catch (e) {}
    }
    return `$${(cents / 100).toFixed(2)}`;
  }

  // Get the JSON script for the product
  function getProductJson() {
    return document.querySelector('script[id^="member-pricing-product-"]');
  }

  // Check if the customer is a member
  function isCustomerMember() {
    if (window.isCustomerLoggedIn) {
      return true;
    }
    return false;
  }

  // Calculate multiplier for member discount based off tier
  function getDiscountMultiplier() {
    const tags =
      document
        .getElementById("member-pricing-block")
        ?.dataset?.customerTags?.split(",")
        .map((t) => t.trim().toLowerCase()) || [];
    switch (true) {
      case tags.includes("tier 1"):
        return 0.75; // 25%
      case tags.includes("tier 2"):
        return 0.7; // 30%
      case tags.includes("tier 3"):
        return 0.65; // 35%
      default:
        return 0.8; // 20%
    }
  }

  // Calculate member price based on variant
  function calcMemberPrice(variant) {
    const title = variant?.title?.toLowerCase() || "";
    const price = variant.price;
    return title.includes("print only")
      ? Math.floor(price * 0.5) // 50% discount on print only
      : Math.floor(price * getDiscountMultiplier()); // dynamic discount based off customer tier
  }

  // Calculate savings amount
  function calcSavings(variant) {
    const memberPrice = calcMemberPrice(variant);
    return variant.price - memberPrice;
  }

  // Get variant ID from URL query parameter
  function getVariantIdFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get("variant");
    return variantId ? parseInt(variantId, 10) : null;
  }

  // Discount text for tooltip
  function discountText(variant) {
    const title = variant?.title?.toLowerCase() || "";
    return title.includes("print only")
      ? "Members get 50% off"
      : "Members get 20% off";
  }

  // Create or update the members savings block
  function updateMemberSavingsBlock(variant) {
    const isMember = isCustomerMember();

    // Only show for non-members
    if (isMember) {
      const existingBlock = document.querySelector(".member-savings-block");
      if (existingBlock) existingBlock.remove();
      return;
    }

    const mPrice = calcMemberPrice(variant);
    const firstAddToCartButton = document.querySelector(
      "button[data-add-to-cart]"
    );

    if (!firstAddToCartButton || mPrice <= 0) return;

    let savingsBlock = document.querySelector(".member-savings-block");

    if (!savingsBlock) {
      // Create the block
      savingsBlock = document.createElement("div");
      savingsBlock.className = "member-savings-block";

      // Insert after the first add-to-cart button
      firstAddToCartButton.parentNode.insertBefore(
        savingsBlock,
        firstAddToCartButton.nextSibling
      );
    }

    // Update content
    if (isMember) {
      savingsBlock.innerHTML = `
          Members Pay: ${money(mPrice)}
        `;
    } else {
      savingsBlock.innerHTML = `
        Members Pay: ${money(mPrice)} <a href="/account/register" data-signup="true">Join Free</a>
      `;
    }
  }

  // Update price & tooltip without replacing the whole block
  function updatePricing(variantId) {
    const scriptEl = getProductJson();
    if (!scriptEl) return;

    const product = JSON.parse(scriptEl.textContent);    
    const variant =
      product.variants.find((v) => v.id == parseInt(variantId, 10)) ||
      product.variants[0];

    const memberPrice = calcMemberPrice(variant);
    const isMember = isCustomerMember();

    // Target elements
    const block = document.querySelector("#member-pricing-block");
    if (!block) return;

    const priceEl = block.querySelector("#mp-member");
    const tooltipBox = block.querySelector(".tooltip-box");
    const tooltipText = discountText(variant);
    const originalPrice = document.querySelector("[data-product-price]");

    if(product.handle === 'h-o-gift-card') {
      block.innerHTML = '';
      return;
    }

    // Update price text
    if (priceEl) {
      priceEl.textContent = money(memberPrice);
      // if (isMember) {
      //   priceEl.textContent = money(memberPrice);
      // } else {
      //   priceEl.textContent = "";
      // }
    }
    if (originalPrice) {
      originalPrice.classList.add("compare-at-price");
    }

    // Update tooltip only if it exists
    if (tooltipBox && !isMember) {
      tooltipBox.innerHTML = `${tooltipText}<br><a href="/account/register" data-signup="true">Join Free</a>`;
    }

    // Update member savings block
    updateMemberSavingsBlock(variant);
  }

  // Initialize price display and variant listeners
  function initPricing() {
    const scriptEl = getProductJson();
    if (!scriptEl) return;

    const product = JSON.parse(scriptEl.textContent);

    // Check for variant ID in URL
    const urlVariantId = getVariantIdFromUrl();
    let initialVariantId = null;

    if (urlVariantId) {
      const urlVariant = product.variants.find((v) => v.id === urlVariantId);
      if (urlVariant) {
        initialVariantId = urlVariant.id;
      }
    }

    const select = document.querySelector(
      'form[action*="/cart/add"] select[name="id"]'
    );
    const radios = document.querySelectorAll(
      'form[action*="/cart/add"] input[name="id"]'
    );

    // Initial price update & variant change listeners
    if (select) {
      updatePricing(initialVariantId || select.value);
      select.addEventListener("change", (e) => updatePricing(e.target.value));
    } else if (radios.length) {
      let updated = false;
      radios.forEach((r) => {
        if (r.checked) {
          updatePricing(initialVariantId || r.value);
          updated = true;
        }
        r.addEventListener("change", () => updatePricing(r.value));
      });

      if (!updated) {
        updatePricing(initialVariantId || product.variants[0].id);
      }
    } else {
      updatePricing(initialVariantId || product.variants[0].id);
    }

    // // Tooltip toggle (persistent)
    // document.addEventListener('click', e => {
    //   const icon = e.target.closest('.tooltip-icon');
    //   const openTooltip = document.querySelector('.tooltip-box.active');

    //   if (icon) {
    //     const tooltip = icon.nextElementSibling || icon.parentElement.querySelector('.tooltip-box');
    //     if (!tooltip) return;
    //     tooltip.classList.toggle('active');
    //     if (openTooltip && openTooltip !== tooltip)
    //       openTooltip.classList.remove('active');
    //   } else if (openTooltip && !e.target.closest('.tooltip-box')) {
    //     openTooltip.classList.remove('active');
    //   }
    // });
  }

  document.addEventListener("DOMContentLoaded", initPricing);
  document.addEventListener("shopify:section:load", initPricing);

  // Calculate and display member price in cart (for non-members only)
  function calculateCartSavings(cart) {
    if (!cart || !cart.items || cart.items.length === 0) {
      // Remove price display if cart is empty
      const savingsDiv = document.querySelector(".cart-member-savings");
      if (savingsDiv) savingsDiv.remove();
      return 0;
    }

    // Calculate what non-members would pay as members
    let totalMemberPrice = 0;

    // Separate items by type
    const framedItems = [];
    const printOnlyItems = [];

    cart.items.forEach((item) => {
      const variantTitle = (item.variant_title || "").toLowerCase();
      if (variantTitle.includes("print only")) {
        printOnlyItems.push(item);
      } else {
        framedItems.push(item);
      }
    });

    // Count framed prints
    const framedCount = countFramedPrints(cart);
    const shouldApplyB2G1 = shouldApplyB2G1Pricing(cart);

    // Calculate framed items pricing
    // 20% off all framed items
    framedItems.forEach((item) => {
      const memberPrice = Math.floor(item.price * 0.8); // 20% off
      totalMemberPrice += memberPrice * item.quantity;
    });

    // Calculate print-only items pricing
    printOnlyItems.forEach((item) => {
      let discountMultiplier;
      if (framedCount >= 1) {
        // 50% off when there's at least 1 framed item
        discountMultiplier = 0.5;
      } else {
        // 20% off when no framed items
        discountMultiplier = 0.8;
      }
      const memberPrice = Math.floor(item.price * discountMultiplier);
      totalMemberPrice += memberPrice * item.quantity;
    });

    // Only show if there's a valid member price
    if (totalMemberPrice <= 0) {
      const savingsDiv = document.querySelector(".cart-member-savings");
      if (savingsDiv) savingsDiv.remove();
      return 0;
    }

    // Find the cart subtotal title element
    const subtotalTitle = document.querySelector(
      "div.cartSubtotalTitle.alignLeft"
    );
    if (!subtotalTitle) return totalMemberPrice;

    // Check if price div already exists
    let savingsDiv = document.querySelector(".cart-member-savings");

    if (!savingsDiv) {
      // Create the price div
      savingsDiv = document.createElement("div");
      savingsDiv.className = "cart-member-savings";

      // Insert before the subtotal title
      subtotalTitle.parentNode.insertBefore(savingsDiv, subtotalTitle);
    }

    // Update the content to show member price
    savingsDiv.innerHTML = `<div style="display:flex;align-items:center;gap:8px">Members Save: ${money(cart.items_subtotal_price - totalMemberPrice)} <img src="${window.icons.unwrapped}" width="24" height="24"/></div><span><a href="/account/register" data-signup="true">Join Free</a></span>`;

    return totalMemberPrice;
  }

  // Count framed prints (eligible for milestone rewards)
  function countFramedPrints(cart) {
    if (!cart || !cart.items) return 0;

    let count = 0;
    cart.items.forEach((item) => {
      const variantTitle = (item.variant_title || "").toLowerCase();

      // Skip if it's a print only item
      if (variantTitle.includes("print only")) {
        return;
      }

      count += item.quantity;
    });

    return count;
  }

  // Check if cart has print-only item with 50% discount applied
  function has50PercentDiscount(cart) {
    if (!cart || !cart.items) return false;

    return cart.items.some((item) => {
      const variantTitle = (item.variant_title || "").toLowerCase();
      if (!variantTitle.includes("print only")) return false;

      return (
        item.discounts &&
        item.discounts.some((discount) => {
          const discountTitle = (discount.title || "").toLowerCase();
          return (
            discountTitle.includes("-50%") || discountTitle.includes("50% off")
          );
        })
      );
    });
  }

  // Check if cart has print-only item with BFCM SALE discount (eligible for 50% OFF)
  function hasPrintOnlyWithBFCM(cart) {
    if (!cart || !cart.items) return false;

    return cart.items.some((item) => {
      const variantTitle = (item.variant_title || "").toLowerCase();
      if (!variantTitle.includes("print only")) return false;

      return (
        item.discounts &&
        item.discounts.some((discount) => {
          const discountTitle = (discount.title || "").toLowerCase();
          return discountTitle.includes("bfcm sale");
        })
      );
    });
  }

  // Check if cart has framed item with BFCM SALE discount (eligible for 30% OFF)
  function hasFramedWithBFCM(cart) {
    if (!cart || !cart.items) return false;

    return cart.items.some((item) => {
      const variantTitle = (item.variant_title || "").toLowerCase();
      if (variantTitle.includes("print only")) return false;

      return (
        item.discounts &&
        item.discounts.some((discount) => {
          const discountTitle = (discount.title || "").toLowerCase();
          return discountTitle.includes("bfcm sale");
        })
      );
    });
  }

  // Check if cart has framed item with 35% SALE discount applied
  function hasB2G1Discount(cart) {
    if (!cart || !cart.items) return false;

    return cart.items.some((item) => {
      const variantTitle = (item.variant_title || "").toLowerCase();
      if (variantTitle.includes("print only")) return false;

      return (
        item.discounts &&
        item.discounts.some((discount) => {
          const discountTitle = (discount.title || "").toLowerCase();
          return discountTitle.includes("35% sale");
        })
      );
    });
  }

  // ==========================================
  // SIZE-BASED BUNDLING LOGIC (SEPARATE)
  // ==========================================

  // Size hierarchy: smaller items can bundle with larger items
  const SIZE_RANKS = {
    small: 1,
    medium: 2,
    large: 3,
    statement: 4,
    gallery: 5,
    collector: 6,
  };

  function getSizeFromVariant(item) {
    // Extract size from variant_title (e.g., "Black / Matted / Collector: 42\" X 62\"")
    const variantTitle = (item.variant_title || "").toLowerCase();

    for (const size in SIZE_RANKS) {
      if (variantTitle.includes(size)) {
        return size;
      }
    }

    return null; // Unknown size
  }

  function getSizeRank(sizeString) {
    return SIZE_RANKS[sizeString?.toLowerCase()] || 0;
  }

  function canItemsBundle(item1, item2) {
    const size1Rank = getSizeRank(getSizeFromVariant(item1));
    const size2Rank = getSizeRank(getSizeFromVariant(item2));

    // If either size is unknown, allow bundling (fallback to old behavior)
    if (size1Rank === 0 || size2Rank === 0) return true;

    // Items can bundle if they're the same size OR item1 >= item2
    return size1Rank >= size2Rank;
  }

  function hasValidB2G1Bundle(cart) {
    if (!cart || !cart.items) return false;

    // Get all framed items (excluding print-only)
    const framedItems = [];
    cart.items.forEach((item) => {
      const variantTitle = (item.variant_title || "").toLowerCase();
      if (!variantTitle.includes("print only")) {
        for (let i = 0; i < item.quantity; i++) {
          framedItems.push(item);
        }
      }
    });

    // Need at least 2 items for B2G1
    if (framedItems.length < 2) return false;

    // Sort items by size rank (largest first)
    framedItems.sort((a, b) => {
      const aRank = getSizeRank(getSizeFromVariant(a));
      const bRank = getSizeRank(getSizeFromVariant(b));
      return bRank - aRank;
    });

    // Check if at least 2 items can bundle together
    // (Largest item can bundle with any smaller/equal item)
    return (
      framedItems.length >= 2 && canItemsBundle(framedItems[0], framedItems[1])
    );
  }

  // Check if cart qualifies for B2G1 pricing (needs 3+ framed items)
  function shouldApplyB2G1Pricing(cart) {
    if (!cart || !cart.items) return false;

    // Get all framed items (excluding print-only)
    const framedItems = [];
    cart.items.forEach((item) => {
      const variantTitle = (item.variant_title || "").toLowerCase();
      if (!variantTitle.includes("print only")) {
        for (let i = 0; i < item.quantity; i++) {
          framedItems.push(item);
        }
      }
    });

    // Need at least 3 items for B2G1 (Buy 2 Get 1 Free)
    if (framedItems.length < 3) return false;

    // Sort items by size rank (largest first)
    framedItems.sort((a, b) => {
      const aRank = getSizeRank(getSizeFromVariant(a));
      const bRank = getSizeRank(getSizeFromVariant(b));
      return bRank - aRank;
    });

    // Check if at least 2 items can bundle together
    return canItemsBundle(framedItems[0], framedItems[1]);
  }

  // ==========================================
  // END SIZE-BASED BUNDLING LOGIC
  // ==========================================

  // Get milestones configuration with enabled and completion status
  function getMilestones(cart) {
    const framedPrintCount = countFramedPrints(cart);
    const has50Off = has50PercentDiscount(cart);
    const hasB2G1 = hasB2G1Discount(cart);
    const hasPrintOnlyBFCM = hasPrintOnlyWithBFCM(cart);
    const hasFramedBFCM = hasFramedWithBFCM(cart);

    const b2g1Enabled =
      (framedPrintCount >= 2 && hasValidB2G1Bundle(cart)) || hasB2G1;

    // Check if cart has any print-only items
    const hasPrintOnly = cart.items.some((item) => {
      const variantTitle = (item.variant_title || "").toLowerCase();
      return variantTitle.includes("print only");
    });

    // Dynamic tooltip for 30% OFF milestone based on frame count
    const milestone30Tooltip = framedPrintCount === 1
      ? "Add an unframed print at 50% off!"
      : "Add 1 more frame and get 35% off!";

    // Dynamic tooltip for 35% OFF milestone based on print-only items
    const milestone35Tooltip = !hasPrintOnly
      ? "Add an unframed print at 50% off!"
      : "Hint: Most Valuable With Same Size Frames!<sup>*</sup>";

    const milestones = [
      {
        id: 1,
        threshold: 1,
        label: "30% OFF",
        message: "You just unwrapped 30% Off!",
        tooltip: milestone30Tooltip,
        enabled: framedPrintCount >= 1 || hasPrintOnlyBFCM,
        completed: hasFramedBFCM || hasPrintOnlyBFCM,
        ineligible: hasB2G1, // 30% OFF is ineligible when 35% OFF is unlocked
      },
      {
        id: 2,
        threshold: 2,
        label: "35% OFF",
        message: "You just unwrapped 35% Off!",
        tooltip: milestone35Tooltip,
        enabled: b2g1Enabled,
        completed: hasB2G1,
      },
      {
        id: 3,
        threshold: 1,
        label: "50% OFF",
        message: "Enjoy Holiday Savings!",
        tooltip: "Enjoy Holiday Savings!",
        enabled: has50Off || hasB2G1,
        completed: has50Off,
      },
    ];

    // Keep original order: 30% OFF, then 35% OFF, then 50% OFF
    // No sorting needed - display in defined order

    return milestones;
  }

  // Template function to generate goals HTML
  function goalsTemplate(cart) {
    if (!cart || !cart.items || cart.items.length === 0) {
      return "";
    }

    // Get milestones with completion status (sorted by proximity)
    const milestones = getMilestones(cart);
    const framedPrintCount = countFramedPrints(cart);

    // Check if all milestones are completed
    const allCompleted = milestones.every((m) => m.completed);

    // Determine message
    let messageHtml = "";
    if (framedPrintCount === 0) {
      messageHtml = "Add a framed piece to unlock 50% off this print!";
    } else {
      // Show the last completed milestone
      const completedMilestones = milestones.filter((m) => m.completed);
      const lastCompleted = completedMilestones[completedMilestones.length - 1];
      if (lastCompleted) {
        // messageHtml = `<span class="goal-message"><h3>${lastCompleted.message}</h3><span>${lastCompleted.tooltip}</span></span>`;
        messageHtml = `<span class="goal-message"><span>${lastCompleted.tooltip}</span></span>`;
      }
    }

    // Generate segments
    let segmentsHtml = "";
    // Find the first uncompleted milestone index
    const firstUncompletedIndex = milestones.findIndex((m) => !m.completed);

    milestones.forEach((milestone, index) => {
      // Check if we've progressed past this milestone (any later milestone is completed)
      const hasProgressedPast = milestones.slice(index + 1).some((m) => m.completed);

      // Segment fills if completed OR if we've progressed past it
      const progress = milestone.completed || hasProgressedPast ? 100 : 0;

      // Icon only changes when actually completed
      const iconSrc = milestone.completed
        ? window.icons.wrapped
        : window.icons.unwrapped;

      // First segment (30% OFF) is shorter - 20% of total width
      // Remaining two segments split the rest equally - 40% each
      const segmentWidth = index === 0 ? "20%" : "40%";

      // Show status label only for completed milestones or the first uncompleted one
      const showStatusLabel = true; //milestone.completed || index === firstUncompletedIndex;
      const statusLabel = milestone.completed ? "UNWRAPPED" : (milestone.ineligible ? "INELIGIBLE" : "ELIGIBLE");

      segmentsHtml += `
        <div
          class="upcart-internal-component-segmented-progress-bar__segment upcart-public-component-segmented-progress-bar__segment"
          style="flex: 0 0 ${segmentWidth}"
          data-internal-properties="milestoneIndex=${index}"
        >
          <div
            class="upcart-internal-component-segmented-progress-bar__segment-fill upcart-public-component-segmented-progress-bar__segment-fill"
            style="width: ${progress}%"
          ></div>
          <div class="upcart-internal-component-segmented-progress-bar__milestone upcart-internal-component-segmented-progress-bar__milestone--middle upcart-public-component-segmented-progress-bar__milestone upcart-public-component-segmented-progress-bar__milestone--middle">
            <div
              class="goal-milestone"
              data-internal-properties="isCompleted=${milestone.completed}"
            >
              <img src="${iconSrc}" alt="${
        milestone.label
      }" style="width: 100%; height: 100%;" />
            </div>

            <div class="upcart-internal-component-segmented-progress-bar__milestone-label upcart-internal-component-segmented-progress-bar__milestone-label--align-center upcart-public-component-segmented-progress-bar__milestone-label upcart-public-component-segmented-progress-bar__milestone-label--align-center">
              ${milestone.label}
              ${
                showStatusLabel
                  ? `<div class="goal-status-label" style="text-align: center; margin-top: 4px; font-size: 10px; font-weight: 500; color:#3c9e6f;">
                ${statusLabel}
              </div>`
                  : ""
              }
            </div>

          </div>
        </div>
      `;
    });

    return `
      <div class="upcart-internal-rewards upcart-public-rewards" data-internal-properties="isColumnReversed=false">
        <div
          class="upcart-internal-rewards__message upcart-public-rewards__message"
          data-upcart-chunk="rewards-message"
          data-internal-properties="isColumnReversed=false"
        >
          ${messageHtml}
        </div>
        <div class="upcart-internal-rewards__bar upcart-public-rewards__bar">
          <div class="upcart-internal-component-segmented-progress-bar upcart-public-component-segmented-progress-bar">
            <div class="upcart-internal-component-segmented-progress-bar__segments-container upcart-public-component-segmented-progress-bar__segments-container">
              ${segmentsHtml}
            </div>
          </div>
        </div>
      </div>
    `;
  }

  function calculateGoals(cart) {
    const goalsDiv = document.querySelector("#upcart-goals");
    if (!goalsDiv) return;

    goalsDiv.innerHTML = goalsTemplate(cart);
  }

  window.addEventListener("upcartUpdated", (event) => {
    const cart = event.detail.cart;
    if (isCustomerMember()) {
      // calculateGoals(cart);
      return;
    }
    calculateCartSavings(cart);
  });
  window.addEventListener("upcartLoaded", (event) => {
    const cart = event.detail.cart;
    if (isCustomerMember()) {
      // calculateGoals(cart);
      return;
    }
    calculateCartSavings(cart);
  });

  // Expose functions for testing
  if (typeof globalThis !== 'undefined' && typeof globalThis.vitest !== 'undefined') {
    globalThis.__memberPricing = {
      calculateMemberPrice: calculateCartSavings,
      shouldApplyB2G1Pricing,
      countFramedPrints,
      money,
      getSizeFromVariant,
      getSizeRank,
      canItemsBundle,
      isCustomerMember,
      getDiscountMultiplier,
      goalsTemplate,
      getMilestones,
      has50PercentDiscount,
      hasB2G1Discount,
      hasPrintOnlyWithBFCM,
      hasFramedWithBFCM,
      hasValidB2G1Bundle
    };
  }
})();
